import { ConversationsService } from './services/conversations.service';
import { MenuService } from './services/menu.service';
import { ServerDashboardInfoComponent } from './server/server-dashboard-info.component';
import { ClipboardDirective } from './shared/directives/clipboard.directive';
import { FormService } from './services/form.service';
import { ResponseService } from './services/response.service';
import { PhoneService } from './services/phone.service';
import { ErrorService } from './services/error.service';
import {
  BreadcrumbService,
  Ng2BreadcrumbModule
} from 'ng2-breadcrumb/ng2-breadcrumb';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, HttpModule, JsonpModule } from '@angular/http';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AccountComponent } from './account/account.component';
import { AddCompanyComponent } from './company-view/add-company.component';
import { AddUserComponent } from './user/add-user.component';
import { ApiService } from './services/api.service';
import { AppComponent } from './app.component';
import { ArrayPipe } from './pipes/array.pipe';
import { AssociativeArrayPipe } from './pipes/associative-array.pipe';
import { AuthGuard } from './services/auth.guard';
import { ActivationService } from './services/activation.service';
import { AuthService } from './services/auth.service';
import { BreadcrumbsService } from './services/breadcrumbs.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CheckoutComponent } from './checkout/checkout.component';
import { OfferComponent } from './service/offer.component';
import { ServiceOfferComponent } from './service/service-offer.component';
import { ServiceOfferCompanyComponent } from './service/service-offer-company.component';
import { ServiceOfferDetailsComponent } from './service/service-offer-details.component';
import { ServiceOfferPaymentComponent } from './service/service-offer-payment.component';
import { CheckoutGuard } from './services/checkout.guard';
import { CheckoutSelectComponent } from './checkout/checkout-select.component';
import { GroupBoxComponent } from './checkout/group-box.component';
import { CheckoutService } from './services/checkout.service';
import { CocpitComponent } from './cocpit/cocpit.component';
import { CompanyComponent } from './company/company.component';
import { CompanyDefaultGuard } from './services/company.default.guard';
import { CompanyGuard } from './services/company.guard';
import { CompanySelectComponent } from './company-select/company-select.component';
import { CompanyService } from './services/company.service';
import { CompanyViewComponent } from './company-view/company-view.component';
import { ContractComponent } from './contract/contract.component';
import { ContractDetailsComponent } from './contract/contract-details.component';
import { ContractDetailsServiceComponent } from './contract/contract-details-service.component';
import { ContractListComponent } from './contract/contract-list.component';
import { ContractListItemComponent } from './contract/contract-list-item.component';
import { ContractListPipe } from './pipes/contract-list.pipe';
import { ContractMergeComponent } from './contract/contract-merge.component';
import { ContractsService } from './services/contracts.service';
import { CookieLawModule } from 'angular2-cookie-law';
import { CookieWindowComponent } from './cookie-window/cookie-window.component';
import { CoreService } from './services/core.service';
import { DateTimeRangepickerComponent } from './shared/components/datetimerangepicker/datetimerangepicker.component';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { DatarangepickerComponent } from './shared/components/datarangepicker/datarangepicker.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { EditAccountComponent } from './account/edit-account.component';
import { LogonAccountComponent } from './account/logon-account.component';
import { LogonDetailsAccountComponent } from './account/logon-details-account.component';
import { EditCompanyComponent } from './company-view/edit-company.component';
import { EditUserComponent } from './user/edit-user.component';
import { EditUserProfileComponent } from './user-profile/edit-user-profile.component';
import { FilterByKeysPipe } from './pipes/filter-by-keys.pipe';
import { ObjectKeysPipe } from './pipes/object-keys-pipe';
import { FooterComponent } from './layout/footer.component';
import { GeneralComponent } from './general/general.component';
import { GuestGuard } from './services/guest.guard';
import { HeaderComponent } from './layout/header.component';
import { InternalNetworkComponent } from './internal-network/internal-network.component';
import { InternalNetworkListComponent } from './internal-network/internal-network-list.component';
import { IpmiService } from './services/ipmi.service';
import { LanguageService } from './services/language.service';
import { LoginComponent } from './login/login.component';
import { LoginVerificationComponent } from './login/login-verification.component';
import { LongMessagePipe } from './pipes/long-message.pipe';
import { MenuComponent } from './layout/menu.component';
import { RegulationMenuComponent } from './layout/regulation-menu.component';
import { MessageListPipe } from './pipes/message-list.pipe';
import { MessageThreadComponent } from './messages/message-thread.component';
import { MessagesComponent } from './messages/messages.component';
import { MessagesListComponent } from './messages/messages-list.component';
import { MessagesService } from './services/messages.service';
import { MomentModule } from 'angular2-moment';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { NewInternalNetworkComponent } from './internal-network/new-internal-network.component';
import { NewMessageComponent } from './messages/new-message.component';
import { NewPasswordComponent } from './login/new-password.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterServers } from './pipes/filter-servers.pipe';
import { PanelComponent } from './panel/panel.component';
import { PayUService } from './services/payu.service';
import { PaymentListComponent } from './payments/payment-list.component';
import { PaymentsComponent } from './payments/payments.component';
import { PaymentsHistoryComponent } from './payments/payments-history.component';
import { PaymentsService } from './services/payments.service';
import { PolishPricePipe } from './pipes/polish-price.pipe';
import { RegisterComponent } from './register/register.component';
import { RemindComponent } from './login/remind.component';
import { ReversePipe } from './pipes/reverse.pipe';
import { RoundPipe } from './pipes/round.pipe';
import { ServerAlertsComponent } from './server/server-alerts.component';
import { ServerComponent } from './server/server.component';
import { ServerDashboardComponent } from './server/server-dashboard.component';
import { CloudDashboardComponent } from './cloud/cloud-dashboard.component';
import { CloudComponent } from './cloud/cloud.component';
import { BackupftpDashboardComponent } from './backupftp/backupftp-dashboard.component';
import { BackupftpComponent } from './backupftp/backupftp.component';
import { VMDashboardComponent } from './vm/vm-dashboard.component';
import { VMComponent } from './vm/vm.component';
import { ServerDevicesComponent } from './server/server-devices.component';
import { ServerIpmiComponent } from './server/server-ipmi.component';
import { ServerListComponent } from './server/server-list.component';
import { ServerMonitoringComponent } from './server/server-monitoring.component';
import { ServerParametersComponent } from './server/server-parameters.component';
import { ServerServicesComponent } from './server/server-services.component';
import { ServersService } from './services/servers.service';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';
import { SpinnerModule } from 'angular2-spinner/dist';
import { TermsComponent } from './terms/terms.component';
import { TextMaskModule } from 'angular2-text-mask';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UserComponent } from './user/user.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserService } from './services/user.service';
import { routing } from './app.routing';
import { NoBlankDirective } from './shared/directives/no-blank.directive';
import { DurationPipe } from './pipes/duration.pipe';
import { ExtractConversationTitleDirective } from './shared/directives/extract-conversation-title.directive';
import { ModalModule } from 'ngx-modal';
import { TooltipModule } from 'ngx-tooltip';
import { AcceptingRegulations } from './accepting/regulations.component';
import { RegulationsService } from './services/regulations.service';
import { RegulationGuard } from './services/regulations.guard';
import { ActivationComponent } from './activation/confirm.component';
import { DsPaginationComponent } from './pagination/pagination.component';
import { DomainListComponent } from './domain/domain-list.component';
import { DomainComponent } from './domain/domain.component';
import { DomainsService } from './services/domains.service';
import { DomainDetailsComponent } from './domain/domain-details.component';
import { DomainRecordsService } from './services/domain-record.service';
import { RodoComponent } from './rodo/rodo.component';
import { RodoGuard } from './services/rodo.guard';
import { RodoService } from './services/rodo.service';
import { RodoClientService } from './services/rodo-client.service';
import { CheckoutSummaryComponent } from './checkout/checkout-summary.component';
import { ServiceOfferSummaryComponent } from './service/service-offer-summary.component';
import { CheckoutServerListComponent } from './checkout/checkout-server-list.component';
import { CheckoutVMComponent } from './checkout/checkout-vm.component';
import { LocalStorageService } from './services/local-storage.service';
import { CheckoutCompanyComponent } from './checkout/checkout-company.component';
import { CheckoutPaymentComponent } from './checkout/checkout-payment.component';
import { PaymentSuccessComponent } from './payments/payment-success.component';
import { PaymentFailureComponent } from './payments/payment-failure.component';
import { CheckoutOrderAcceptedComponent } from './checkout/checkout-order-accepted.component';
import { ServerRRDComponent } from './server/server-rrd.component';
import { ServerTransferComponent } from './server/server-transfer.component';

import { MaintanceService } from './services/maintance.service';
import { NewsService } from './services/news.service';
import { NewsComponent } from './news/news.component';
import { NewsListComponent } from './news/news-list.component';
import { NewsHistoryComponent } from './news/news-history.component';
import { DateService } from './services/date.service';
import { CartService } from './services/cart.service';
import { CartDashboardComponent } from './cart/cart-dashboard.component';
import { CartComponent } from './cart/cart.component';
import { CartListComponent } from './cart/cart-list.component';
import { CartListFinishedComponent } from './cart/cart-list-finished.component';

// import { CookieService } from 'angular2-cookie/services/cookies.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: Http) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
    RegisterComponent,
    PanelComponent,
    MenuComponent,
    MessagesComponent,
    MessagesListComponent,
    NewMessageComponent,
    MessageThreadComponent,
    PaymentsComponent,
    PaymentsHistoryComponent,
    InternalNetworkComponent,
    InternalNetworkListComponent,
    NewInternalNetworkComponent,
    PaymentListComponent,
    PaymentSuccessComponent,
    PaymentFailureComponent,
    CheckoutServerListComponent,
    CheckoutVMComponent,
    CheckoutCompanyComponent,
    FilterServers,
    CompanySelectComponent,
    CompanyComponent,
    UserProfileComponent,
    EditUserProfileComponent,
    AccountComponent,
    EditAccountComponent,
    LogonAccountComponent,
    LogonDetailsAccountComponent,
    CompanyViewComponent,
    AddCompanyComponent,
    EditCompanyComponent,
    UserComponent,
    AddUserComponent,
    EditUserComponent,
    ContractComponent,
    ContractListComponent,
    ContractMergeComponent,
    ServerComponent,
    ServerMonitoringComponent,
    ServerParametersComponent,
    ServerDevicesComponent,
    ServerServicesComponent,
    ContractDetailsComponent,
    ServerAlertsComponent,
    ServerDashboardComponent,
    CloudDashboardComponent,
    CloudComponent,
    BackupftpDashboardComponent,
    BackupftpComponent,
    VMDashboardComponent,
    VMComponent,
    ServerDashboardInfoComponent,
    MonitoringComponent,
    ContractListItemComponent,
    CheckoutComponent,
    OfferComponent,
    ServiceOfferComponent,
    ServiceOfferCompanyComponent,
    ServiceOfferDetailsComponent,
    ServiceOfferPaymentComponent,
    CheckoutSummaryComponent,
    ServiceOfferSummaryComponent,
    CheckoutPaymentComponent,
    CheckoutOrderAcceptedComponent,
    FooterComponent,
    CookieWindowComponent,
    ContractListPipe,
    ObjectKeysPipe,
    NewPasswordComponent,
    CheckoutSelectComponent,
    ArrayPipe,
    ContractDetailsServiceComponent,
    AssociativeArrayPipe,
    MessageListPipe,
    RemindComponent,
    ReversePipe,
    TermsComponent,
    GroupBoxComponent,
    RoundPipe,
    PolishPricePipe,
    LoginVerificationComponent,
    CocpitComponent,
    GeneralComponent,
    LongMessagePipe,
    ServerIpmiComponent,
    ServerListComponent,
    FilterByKeysPipe,
    DatarangepickerComponent,
    DateTimeRangepickerComponent,
    NoBlankDirective,
    DurationPipe,
    ExtractConversationTitleDirective,
    ClipboardDirective,
    AcceptingRegulations,
    RegulationMenuComponent,
    RodoComponent,
    ActivationComponent,
    DsPaginationComponent,
    DomainComponent,
    DomainListComponent,
    DomainDetailsComponent,
    ServerRRDComponent,
    ServerTransferComponent,
    NewsComponent,
    NewsListComponent,
    NewsHistoryComponent,
    CartComponent,
    CartListComponent,
    CartDashboardComponent,
    CartListFinishedComponent,
  ],
  imports: [
    AngularDateTimePickerModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    JsonpModule,
    Ng2BreadcrumbModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [Http]
      }
    }),
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
    SlimLoadingBarModule.forRoot(),
    SpinnerModule,
    CookieLawModule,
    NgxPaginationModule,
    TextMaskModule,
    Daterangepicker,
    ModalModule,
    TooltipModule,
    routing,
  ],
  providers: [
    AuthGuard,
    GuestGuard,
    CartService,
    CompanyDefaultGuard,
    CompanyGuard,
    RegulationGuard,
    RodoGuard,
    AuthService,
    ApiService,
    CompanyService,
    LocalStorageService,
    UserService,
    BreadcrumbService,
    BreadcrumbsService,
    LanguageService,
    ContractsService,
    CheckoutService,
    CheckoutGuard,
    CoreService,
    MessagesService,
    PayUService,
    PaymentsService,
    ServersService,
    IpmiService,
    ErrorService,
    ResponseService,
    PhoneService,
    FormService,
    RegulationsService,
    RodoClientService,
    RodoService,
    MenuService,
    ConversationsService,
    ActivationService,
    DomainsService,
    DomainRecordsService,

    MaintanceService,
    NewsService,
    DateService,
    // Modal,
    // BSModalContext
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts